function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20.02 10.7l-2.8 1.77-5.66-5.66 1.76-2.8c.82-1.29 2.46-1.35 3.67-.15l3.18 3.18c1.13 1.13 1.06 2.89-.15 3.66z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M14.71 19.95L6 20.98c-.6.07-1.14-.02-1.59-.24a2.39 2.39 0 01-1.11-1.11c-.22-.45-.3-.99-.24-1.58L4.1 9.33c.25-2.18 1.06-2.89 3.36-2.76l4.12.25 5.66 5.66.24 4.12c.21 2.3-.58 3.1-2.77 3.35z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.98 17.15L4.4 20.73a2.39 2.39 0 01-1.11-1.11l3.59-3.59c.31-.3.81-.3 1.11 0 .31.32.31.81-.01 1.12z"
})));